var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-avatar',{attrs:{"size":_vm.size}},[(_vm.selectedImageUrl)?_c('img',{attrs:{"src":_vm.selectedImageUrl,"alt":"avatar"}}):_c('div',{staticClass:"initial"},[_vm._v(" "+_vm._s(_vm.initial)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }